import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            内容分类
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            浏览不同频道，发现你感兴趣的视频内容领域
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 bg-background-50 border border-background-200/70 rounded-lg hover:border-accent-200 hover:bg-accent-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${cat.icon} text-xl text-accent-600 group-hover:text-accent-700`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-accent-600 transition-colors duration-200 whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}